// src/components/practice/tasks/PresentationWithSummaryTask.jsx
import React from 'react';
import { Mic } from 'lucide-react';

const PresentationWithSummaryTask = ({ partData }) => {
    const { task, partName } = partData;
    return (
        <div>
            <h4 className="font-bold text-xl mb-4 flex items-center">
                <Mic className="mr-2 h-6 w-6 text-blue-600"/>
                {partName}
            </h4>
            <div className="bg-gray-50 p-6 rounded-lg prose max-w-none space-y-6">
                <div>
                    <h5 className="font-semibold text-lg">Teil 1A: Präsentation (ca. 3 Minuten)</h5>
                    <p>In einer Lehrveranstaltung Ihrer Universität sollen Sie eine Präsentation halten. Wählen Sie eines der Themen aus. Denken Sie auch an eine Einleitung und einen Schluss bzw. ein Fazit. Ihre Präsentation soll gut gegliedert sein und das Thema verständlich und ausführlich darzustellen. Im Anschluss werden Ihnen Fragen gestellt.</p>
                </div>

                 {task?.topics && (
                    <div className="mt-4">
                        <h5 className="font-semibold">Beispielthemen:</h5>
                        <div className="space-y-3 mt-2">
                            {task.topics.map(topic => (
                                <div key={topic.id} className="p-4 bg-white rounded-lg border border-gray-200">
                                    <p className="font-normal text-gray-800">{topic.title}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

                <div>
                    <h5 className="font-semibold text-lg">Teil 1B: Zusammenfassung und Anschlussfragen (ca. 2 Minuten)</h5>
                    <p>Nach der Präsentation fasst die jeweils andere Teilnehmerin bzw. der jeweils andere Teilnehmer zusammen, was für sie bzw. ihn besonders bemerkenswert war. Außerdem stellt sie bzw. er mindestens eine Frage zum Thema der Präsentation.</p>
                </div>
            </div>
        </div>
    );
};

export default PresentationWithSummaryTask;